import { create } from 'zustand';

interface HubDeleteModalProps {
  hubName?: string;
  hubPk: number;
  isOpen: boolean;
  trapsConnected: number;
  hubObjectSlug?: string;
  closeDeleteHubModal: () => void;
  openDeleteHubModal: (hubName: string, hubPk: number, trapsConnected: number, hubObjectSlug?: string) => void;
}

export const useHubDeleteModalStore = create<HubDeleteModalProps>(set => ({
  isOpen: false,
  hubName: '',
  hubPk: 0,
  trapsConnected: 0,
  hubObjectSlug: '',
  openDeleteHubModal: (hubName: string, hubPk: number, trapsConnected: number, hubObjectSlug?: string) =>
    set({ isOpen: true, hubName, hubPk, trapsConnected, hubObjectSlug }),
  closeDeleteHubModal: () => set({ isOpen: false, hubName: '' }),
}));
